import { useAutoCreatePrivyEmbeddedWallet } from './useAutoCreatePrivyEmbeddedWallet';
import { useSyncPrivyLogout } from './useSyncPrivyLogout';
import { useSyncPrivyWalletMapping } from 'src/hooks/wallets/privy/mappings/useSyncPrivyWalletMapping';
import { useDisableEmbeddedWalletForBlacklistedWallets } from './useDisableEmbeddedWalletForBlacklistedWallets';

export const useSyncPrivy = () => {
	useAutoCreatePrivyEmbeddedWallet();
	useSyncPrivyLogout();
	useSyncPrivyWalletMapping();
	useDisableEmbeddedWalletForBlacklistedWallets();
};
